import { mapFieldArrToObjSchema } from '../../validation/useValidation';
import * as R from 'ramda';
export const categoryModel = {
    id:	19,
    type:	1,
    first_name:	"فاطمه",
    last_name:	"صادق زاده قمصری",
    gender:	0,
    mobile:	"09124578353",
    email:	null,
    national_code:	null,
    birth_day:	null,
    created_at:	"2021-04-10T09:09:29.000000Z",
    updated_at:	"2021-04-10T09:09:29.000000Z",
};

export const singleAdminInit = {
    first_name:	"",
    last_name:	"",
    gender:	0,
    mobile:	"",
    email:	null,
    national_code:	null,
    birth_day:	null,
    created_at:	"",
    updated_at:	"",
};

export const FormAdminInit = {
    first_name:	"",
    last_name:	"",
    mobile:	"",
    national_code:	"",
    username:	"",
    password:	"",
};

const adminValidationsArr = [
    ['first_name', 'string'],
    ['last_name', 'string'],
    ['national_code', 'string'],
    ['mobile', 'string'],
    ['username', 'string'],
    ['password', 'string'],
];


export const adminValidations = mapFieldArrToObjSchema(adminValidationsArr);
